import { useEffect } from 'react'

import { useQuery } from '@tanstack/react-query'

import { fetchSetupCommands } from '@/core/api'
import { TECHNOLOGY_SETUP_MAPPING } from '@/core/config/technologies'
import { CODES_QUERY_KEY } from '@/core/hooks/useInstallationConfig/constants'
import { useCodeStore } from '@/core/stores/codeStore'
import { getGatewayConfig } from '@/core/utils'

export function useSetupCommands() {
  const config = getGatewayConfig()
  const technologySetupCommands = useCodeStore((state) => state.technologySetupCommands)

  const query = useQuery({
    queryKey: [...CODES_QUERY_KEY, config.host],
    queryFn: () => fetchSetupCommands(config, TECHNOLOGY_SETUP_MAPPING),
    enabled: !!config.host,
    retry: 2,
    staleTime: 5 * 60 * 1000,
  })

  useEffect(() => {
    if (query.data) {
      useCodeStore.setState({ technologySetupCommands: query.data })
    }
  }, [query.data])

  return {
    technologySetupCommands: query.data ?? technologySetupCommands,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
  }
}
